<template>
  <v-app>
    <Header />
    <v-content>
      <div id="content-wrapper">
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <left-panel @goTo="goTo($event)" />
            </v-col>
            <v-col cols="12" md="8">
              <router-view />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import LeftPanel from "./LeftPanel";
import Footer from "./Footer";
import Header from "./Header";

export default {
  name: "App",

  data() {
    return {};
  },

  computed: {
    currentView() {
      return this.$store.state.currentView;
    },
  },

  components: {
    "left-panel": LeftPanel,
    Footer,
    Header,
  },

  watch: {
    currentView: function (val) {
      this.$router.push({ name: val }).catch(() => {});
    },
  },

  methods: {
    goTo(view) {
      this.$store.dispatch("loadView", view);
    },
  },
};
</script>

<style>
#content-wrapper {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #212121;
  font-weight: 300;
  padding: 20px 20px 100px 20px;
}

.dialog-screen-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.575);

  display: flex;
  justify-content: center;
  align-items: center;
}

/* common css */
.pt-0 {
  padding-top: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

/* Page headers */
.header.text-left {
  font-size: 26px;
  font-weight: normal;
}

/* Filter and create buttons */

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

.action-buttons button {
  color: white !important;
  letter-spacing: normal;
  text-transform: none;
}

.action-buttons .filter-btn {
  margin-right: 20px;
}

@media only screen and (max-width: 959px) {
  .action-buttons {
    justify-content: flex-start;
  }
}
</style>
